<div class="container-fluid bg-dark-black text-light">
  <div class="row py-4">
    <div class="col-12 col-md-6 text-center text-md-left">
      © Copyright 2014
      <a href="https://sumant-mishra.netlify.app/">Sumant Mishra</a>
    </div>
    <div class="mt-4 mt-md-0 col-12 col-md-6 text-md-right text-center">
      Created by Sumant Mishra
    </div>
  </div>
</div>
